var map = {
	"./staging_new_h_variant_1.json": [
		38326,
		8326
	],
	"./staging_new_h_variant_2.json": [
		1890,
		1890
	],
	"./staging_new_t_variant_1.json": [
		27136,
		7136
	],
	"./staging_new_t_variant_2.json": [
		35717,
		5717
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 17864;
module.exports = webpackAsyncContext;